import { render } from "./ViewFixedQuestions.vue?vue&type=template&id=641aa028&scoped=true"
import script from "./ViewFixedQuestions.vue?vue&type=script&lang=js"
export * from "./ViewFixedQuestions.vue?vue&type=script&lang=js"

import "./ViewFixedQuestions.vue?vue&type=style&index=0&id=641aa028&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-641aa028"]])

export default __exports__